import { Button, Flex, Heading, Link } from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import Swal from "sweetalert2";
import VisualizarInfo from "../Doenca/VisualizarInfo";
import { Link as ReactLink, useHistory } from "react-router-dom";
import VisitasService from "../../../main/services/VisitasService";
import {
  Permission,
  criancaFunc,
  visitasFunc,
} from "../../../helpers/Funcionalidades";
import { useAuthProvider } from "../../../Context/AuthProvider";

const VisualizarVisitas = (props) => {
  document.title = "MCA - Visitas - Visualizar";
  let history = useHistory();

  const _IsMounted = useRef(false);
  const [visitas, setVisitas] = useState([]);
  const custom_date = new Date(visitas?.dataVisita).toLocaleDateString("pt-BR");
  const [visitasLoaded, setVisitasLoaded] = useState(false);
  const { roleKeycloack } = useAuthProvider();

  useEffect(() => {
    _IsMounted.current = true;
    fetchData();
    return () => {
      _IsMounted.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const gestor =
    roleKeycloack && roleKeycloack.includes(criancaFunc.visualizarTudo);

  function fetchData() {
    VisitasService.getVisita(props.match.params.id)
      .then((res) => {
        setVisitas(res.data);
        setVisitasLoaded(true);
      })
      .catch((err) => {
        Swal.fire({
          title: "Atenção!",
          text: "Registro não encontrado",
          icon: "warning",
          confirmButtonText: "Fechar",
          confirmButtonColor: "#169499",
        }).then(() => {
          history.push("/visitas/lista");
        });
      });
  }

  function checkStatus() {
    Swal.fire({
      title: "Ao excluir, as informações sobre essa visita serão excluídas.",
      text: "Deseja Continuar? ",
      icon: "error",
      showCancelButton: true,
      confirmButtonColor: "#169499",
      cancelButtonColor: "#169499",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((result) => {
      if (result.isConfirmed) {
        VisitasService.deleteVisitas(props.match.params.id).then((res) => {
          history.push("/visitas/lista");
          Swal.fire({
            title: "Sucesso!",
            text: "Registro Excluído.",
            icon: "success",
            confirmButtonText: "Continuar",
            confirmButtonColor: "#169499",
          });
        });
      }
    });
  }

  return (
    <Flex
      pt={"20px"}
      px={["5px", "30px"]}
      h="100%"
      flexDir="column"
      w="100%"
      maxW="2000px"
      overflow="auto"
      pb={["10px", "20px"]}
    >
      <Flex flexDir="row" justifyContent="space-between">
        <Heading fontSize={"large"}>Visualizar Visita</Heading>
        <Link
          as={ReactLink}
          to="/visitas/lista"
          _hover={{ textDecoration: "none" }}
        >
          <Button colorScheme={"teal"} px={16}>
            Voltar
          </Button>
        </Link>
      </Flex>
      <Flex flexDir="column">
        <Flex
          mt="25px"
          flexDir="column"
          borderRadius="0.3rem"
          w="100%"
          overflow="hidden"
        >
          <VisualizarInfo
            title="Criança/Adolescente"
            info={visitas?.pessoaFisicaCriancaResponse?.nome || ""}
            bgColor="#F9FAFB"
          />
          <VisualizarInfo
            title="Visitante"
            info={visitas?.pessoaFisicaVisitanteResponse?.nome}
            bgColor="#FFFFFF"
          />

          <VisualizarInfo
            title="Vínculo"
            info={visitas?.vinculo}
            bgColor="#F9FAFB"
          />

          <VisualizarInfo
            title="Data da visita"
            info={custom_date}
            bgColor="#FFFFFF"
          />
        </Flex>
        <Flex mt={10} justifyContent="end">
          <Flex
            justifyContent="space-between"
            display={{ base: "block", md: "flex" }}
          >
            {(gestor ||
              (!gestor &&
                visitasLoaded &&
                !visitas?.pessoaFisicaCriancaResponse?.desligada)) && (
              <Permission
                roleKeycloack={roleKeycloack}
                func={visitasFunc.visitaCadastrar}
              >
                <Link
                  as={ReactLink}
                  to={"/visitas/cadastrar"}
                  _hover={{ textDecoration: "none" }}
                >
                  <Button
                    mr={2}
                    mt={4}
                    colorScheme={"teal"}
                    px={14}
                    type="button"
                  >
                    Cadastrar
                  </Button>
                </Link>
              </Permission>
            )}

            <Permission
              roleKeycloack={roleKeycloack}
              func={visitasFunc.visitaEditar}
            >
              <Link
                as={ReactLink}
                to={"/visitas/editar/" + visitas.idVisita}
                _hover={{ textDecoration: "none" }}
              >
                <Button
                  mr={2}
                  mt={4}
                  colorScheme={"teal"}
                  px={14}
                  type="button"
                >
                  Editar
                </Button>
              </Link>
            </Permission>

            <Permission
              roleKeycloack={roleKeycloack}
              func={visitasFunc.visitaExcluir}
            >
              <Button
                mt={4}
                mr={2}
                colorScheme={"teal"}
                px={14}
                onClick={(e) => {
                  checkStatus(e.target.dataset.acao);
                }}
                type="button"
              >
                Excluir
              </Button>
            </Permission>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};
export default VisualizarVisitas;
